import React, { useState } from 'react';
import { Search, Heart, ShoppingCart, ChevronDown } from 'lucide-react';

const Header = ({ currentPage, setCurrentPage }) => {
  const [isLearnDropdownOpen, setIsLearnDropdownOpen] = useState(false);
  
  const handleNavigation = (page) => {
    setCurrentPage(page);
  };

  const learnMenuItems = [
    "What Is EMF?",
    "How To Protect Yourself From EMF Radiation?",
    "What You Need To Know About EMF Sensitivity",
    "5 Tips To Reduce EMF Exposure On Long Flights",
    "Does Wi-Fi Cause Cancer? Health Risks And Facts",
    "How EMF Blocking Laptop Pads Protect Your Health"
  ];

  return (
    <>
      {/* Top Banner */}
   
    <div className="bg-gradient-to-r from-purple-600 via-pink-500 to-blue-500 text-white text-center py-2 px-4 relative">
      <div className="text-sm font-medium">
        Rated 4.8-stars across 1k+ reviews
      </div>
      <button className="absolute right-4 top-1/2 transform -translate-y-1/2 text-white hover:text-gray-200 transition-colors duration-200">
        ✕
      </button>
    </div>
 

      {/* Navigation Header */}
      <nav className="bg-white shadow-sm border-b sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex items-center justify-between h-16">
            {/* Logo */}
            <div className="flex items-center space-x-2">
              <div className="w-10 h-10 bg-blue-500 rounded-full flex items-center justify-center">
                <div className="text-white font-bold text-lg">E</div>
              </div>
              <span className="text-2xl font-bold text-gray-800">EShopStream</span>
            </div>

            {/* Navigation Links */}
            <div className="hidden md:flex items-center space-x-8">
              <button 
                onClick={() => handleNavigation('home')}
                className={`font-medium transition-colors ${
                  currentPage === 'home' ? 'text-blue-500' : 'text-gray-700 hover:text-blue-500'
                }`}
              >
                HOME
              </button>
              <button 
                onClick={() => handleNavigation('shop')}
                className={`font-medium transition-colors ${
                  currentPage === 'shop' ? 'text-blue-500' : 'text-gray-700 hover:text-blue-500'
                }`}
              >
                SHOP NOW
              </button>
              
              {/* Learn About EMF with Dropdown */}
              <div 
                className="relative"
                onMouseEnter={() => setIsLearnDropdownOpen(true)}
                onMouseLeave={() => setIsLearnDropdownOpen(false)}
              >
                <button 
                  onClick={() => handleNavigation('learn')}
                  className={`font-medium transition-colors flex items-center space-x-1 ${
                    currentPage === 'learn' ? 'text-blue-500' : 'text-gray-700 hover:text-blue-500'
                  }`}
                >
                  <span>LEARN ABOUT EMF</span>
                  <ChevronDown className="w-4 h-4" />
                </button>
                
                {/* Dropdown Menu */}
                {isLearnDropdownOpen && (
                  <div className="absolute top-full left-0 mt-1 w-80 bg-white border border-gray-200 rounded-lg shadow-lg z-50">
                    <div className="py-2">
                      {learnMenuItems.map((item, index) => (
                        <button
                          key={index}
                          onClick={() => {
                            handleNavigation('learn');
                            setIsLearnDropdownOpen(false);
                          }}
                          className="block w-full text-left px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 hover:text-blue-500 transition-colors border-b border-gray-100 last:border-b-0"
                        >
                          {item}
                        </button>
                      ))}
                    </div>
                  </div>
                )}
              </div>
              
              <button 
                onClick={() => handleNavigation('contact')}
                className={`font-medium transition-colors ${
                  currentPage === 'contact' ? 'text-blue-500' : 'text-gray-700 hover:text-blue-500'
                }`}
              >
                CONTACT
              </button>
              <button 
                onClick={() => handleNavigation('about')}
                className={`font-medium transition-colors ${
                  currentPage === 'about' ? 'text-blue-500' : 'text-gray-700 hover:text-blue-500'
                }`}
              >
                ABOUT US
              </button>
            </div>

            {/* Right Side Icons */}
            <div className="flex items-center space-x-4">
              <Search className="w-6 h-6 text-gray-600 hover:text-blue-500 cursor-pointer" />
              <Heart className="w-6 h-6 text-gray-600 hover:text-blue-500 cursor-pointer" />
              <div className="relative">
                <ShoppingCart className="w-6 h-6 text-gray-600 hover:text-blue-500 cursor-pointer" />
                <span className="absolute -top-2 -right-2 bg-blue-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
                  0
                </span>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Header;